// theme.ts
export const themes = {
  light: {
    background: "#ffffff",
    text: "#000000",
  },
  dark: {
    background: "#161D27",
    text: "#ffffff",
  },
};
